<div class="form-view-container">
    <h2 class="fw-bold mb-3 text-center text-light">Check Your Email</h2>
    <p class="form-instruction text-center mb-4">We sent a 6-digit code to <strong class="text-light">{{ recoveryEmail()
            }}</strong>. Enter it below to reset your password.</p>
    <form (ngSubmit)="verifyCode()">
        <!-- Recovery Code Input -->
        <div class="code-input-group mb-4" role="group" aria-label="6-digit recovery code">
            <input type="text" class="form-control code-input" id="recoveryCode1" maxlength="1" pattern="\d"
                inputmode="numeric" autocomplete="one-time-code" aria-label="Digit 1 of 6" [ngModel]="codeDigit1()"
                (ngModelChange)="codeDigit1.set($event)" (input)="handleCodeInput($event, 1)"
                (keydown)="handleCodeKeyDown($event, 1)" name="d1" required>
            <input type="text" class="form-control code-input" id="recoveryCode2" maxlength="1" pattern="\d"
                inputmode="numeric" aria-label="Digit 2 of 6" [ngModel]="codeDigit2()"
                (ngModelChange)="codeDigit2.set($event)" (input)="handleCodeInput($event, 2)"
                (keydown)="handleCodeKeyDown($event, 2)" name="d2" required>
            <input type="text" class="form-control code-input" id="recoveryCode3" maxlength="1" pattern="\d"
                inputmode="numeric" aria-label="Digit 3 of 6" [ngModel]="codeDigit3()"
                (ngModelChange)="codeDigit3.set($event)" (input)="handleCodeInput($event, 3)"
                (keydown)="handleCodeKeyDown($event, 3)" name="d3" required>
            <input type="text" class="form-control code-input" id="recoveryCode4" maxlength="1" pattern="\d"
                inputmode="numeric" aria-label="Digit 4 of 6" [ngModel]="codeDigit4()"
                (ngModelChange)="codeDigit4.set($event)" (input)="handleCodeInput($event, 4)"
                (keydown)="handleCodeKeyDown($event, 4)" name="d4" required>
            <input type="text" class="form-control code-input" id="recoveryCode5" maxlength="1" pattern="\d"
                inputmode="numeric" aria-label="Digit 5 of 6" [ngModel]="codeDigit5()"
                (ngModelChange)="codeDigit5.set($event)" (input)="handleCodeInput($event, 5)"
                (keydown)="handleCodeKeyDown($event, 5)" name="d5" required>
            <input type="text" class="form-control code-input" id="recoveryCode6" maxlength="1" pattern="\d"
                inputmode="numeric" aria-label="Digit 6 of 6" [ngModel]="codeDigit6()"
                (ngModelChange)="codeDigit6.set($event)" (input)="handleCodeInput($event, 6)"
                (keydown)="handleCodeKeyDown($event, 6)" name="d6" required>
        </div>

        <!-- Submit Button -->
        <div class="mt-4">
            <button type="submit"
                class="btn btn-danger w-100 d-flex align-items-center justify-content-center btn-submit"
                style="height: 4rem;" [disabled]="recoveryCode().length < 6"
                aria-label="Verify recovery code" title="Verify Recovery Code">
                <span class="fw-bold fs-5 text-white">VERIFY</span>
            </button>
        </div>
    </form>
    <div class="mt-5 text-center small login-links">
        <a href="#" (click)="$event.preventDefault(); changeView.emit('login')" role="button"
            class="fw-bold text-decoration-none text-uppercase login-link">Back to Sign In</a>
    </div>
</div>